export default /^(?=.*[a-z])(?=.*[0-9])(?=.{8,})/;
